export default function useEmbeddedBrowser() {}
